/*
 * From https://www.redblobgames.com/maps/terrain-from-noise/
 * Copyright 2022 Red Blob Games <redblobgames@gmail.com>
 * License: Apache-2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>
 */

type RGBA = [number, number, number, number];

export function CanvasIslandDistanceChart(canvas: HTMLCanvasElement, distanceFn: (nx: number, ny: number) => number) {
    const LAND_COLOR = [0, 255, 0, 255];
    const WATER_COLOR = [0, 128, 255, 255];
    const LOW_COLOR = [255, 255, 255, 255];
    const HIGH_COLOR = [0, 0, 255, 255];
    
    function colorFn(nx: number, ny: number, output_color: RGBA) {
        let d = distanceFn(nx, ny);
        if (d < 0 || d > 1) throw `Invalid distance(${nx},${ny}) = ${d})`;
        for (let channel = 0; channel < 4; channel++) {
            let c = (1-d) * LAND_COLOR[channel] + d * WATER_COLOR[channel];
            if (d < 0.1) c = LOW_COLOR[channel];
            if (d > 0.9) c = HIGH_COLOR[channel];
            output_color[channel] = c;
        }
    }
    
    CanvasDistanceChart(canvas, colorFn);
}

export function CanvasDistanceChart(canvas: HTMLCanvasElement, colorFn: (nx: number, ny: number, output_color: RGBA) => void) {
    const w = 100, h = 100;
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, w, h);
    const pixels = imageData.data;
    let color: RGBA = [0, 0, 0, 0];
    
    for (let x = 0; x < w; x++) {
        for (let y = 0; y < h; y++) {
            let p = 4 * (y * w + x);
            colorFn(2*x/w - 1, 2*y/h - 1, color);
            for (let channel = 0; channel < 4; channel++) {
                pixels[p+channel] = color[channel];
            }
        }
    }
    ctx.putImageData(imageData, 0, 0);
}
